<template>
    <view-container v-if="ready" :headline="'견적신청 상세'" :maxWidth="'1660px'">
        <!-- 신청 정보 -->
        <infos :inquiry="inquiry" />

        <!-- 신청 상태 (관리자 ru / 업체, 실측기술자 r) -->
        <status v-model="inquiry" @change="save" :isAdmin="isAdmin" />

        <!-- 업체 정보 (관리자 ru) -->
        <selected-interior
            v-if="isAdmin"
            :inquiryResultType="inquiry.inquiryResultType"
            :isAdmin="isAdmin"
            :_inquiry="inquiry._id"
            :interior="inquiry.interior"
            @save="save"
            @saveInterior="saveInterior"
            @showEstimate="showEstimate"
        />
        <requested-interiors
            v-if="isAdmin || isMeasurer"
            :interiors="inquiry.interiors"
            :isAdmin="isAdmin"
            @show-add="$refs['add-interiors'].showOverlay()"
            @showEstimate="showEstimate"
            @saveInterior="saveInterior"
            @clickEstimateRequest="requestEstimate"
        />
        <add-interiors-popup v-if="isAdmin" ref="add-interiors" :inquiry="inquiry" @saveInteriors="saveInteriors" />

        <!-- 실측기본정보 (관리자 ru / 업체 r) -->
        <v-row>
            <v-col><measurement-basic v-model="inquiry.measurementInfo" @clickSave="save" :isAdmin="isAdmin"/></v-col>
            <v-col>
                <measurement-address v-model="inquiry" @clickSave="save" :isAdmin="isAdmin" />
                <measurement-measurer v-model="inquiry.measurementInfo._measurer" @clickSave="save" :isAdmin="isAdmin" />
            </v-col>
            <v-col><measurement-admin-memo v-model="inquiry.measurementInfo.adminMemo" @clickSave="save" :isAdmin="isAdmin"/></v-col>
        </v-row>

        <!-- 실측상세정보 (실측기술자 ru / 관리자, 업체 r) -->
        <measurement-targets v-model="inquiry.measurementInfo" :isMeasurer="isMeasurer" @clickSave="save" />

        <!-- 실측자료 (실측기술자 ru / 관리자, 업체 r) -->
        <measurements v-model="inquiry.measurements" :_inquiry="inquiry._id" :disabled="!isMeasurer" />

        <!-- 견적 작성 (업체 cru) -->
        <add-estimate v-if="isInterior" :inquiry="inquiry" @input="(estimate) => saveEstimate(estimate)" />

        <!-- 견적 열람 (관리자, 실측기술자) -->
        <popup-estimate-1 ref="popup-estimate1" v-model="estimate" :editable="false" @resetEstimate="estimate = undefined" />
        <popup-estimate-2 ref="popup-estimate2" v-model="estimate" :editable="false" @resetEstimate="estimate = undefined" />
        <popup-estimate-file ref="popup-estimateFile" v-model="estimate" :editable="false" @resetEstimate="estimate = undefined" />
    </view-container>
</template>
<script>
import api from "@/api";

import ViewContainer from "@/components/console/dumb/view-container.vue";
import ViewCard from "@/components/console/dumb/view-card.vue";
import Infos from "@/components/console/estimate-inquiry/infos.vue";
import SelectedInterior from "@/components/console/estimate-inquiry/selected-interior.vue";
import RequestedInteriors from "@/components/console/estimate-inquiry/requested-interiors.vue";
import AddInteriorsPopup from "@/components/console/estimate-inquiry/add-interiors-popup.vue";
import Status from "@/components/console/estimate-inquiry/status.vue";
import AddEstimate from "@/components/console/estimate-inquiry/add-estimate.vue";
import PopupEstimate1 from "@/components/console/portfolio/popup-estimate1.vue";
import PopupEstimate2 from "@/components/console/portfolio/popup-estimate2.vue";
import PopupEstimateFile from "@/components/console/portfolio/popup-estimate-file.vue";
import MeasurementBasic from "@/components/console/estimate-inquiry/measurement-basic.vue";
import MeasurementAddress from "@/components/console/estimate-inquiry/measurement-address.vue";
import MeasurementMeasurer from "@/components/console/estimate-inquiry/measurement-measurer.vue";
import MeasurementAdminMemo from "@/components/console/estimate-inquiry/measurement-admin-memo.vue";
import MeasurementTargets from "@/components/console/estimate-inquiry/measurement-targets.vue";
import Measurements from "@/components/console/estimate-inquiry/measurements.vue";

export default {
    components: {
        ViewContainer,
        ViewCard,
        Infos,
        SelectedInterior,
        RequestedInteriors,
        AddInteriorsPopup,
        Status,
        AddEstimate,
        PopupEstimate1,
        PopupEstimate2,
        PopupEstimateFile,
        MeasurementBasic,
        MeasurementAddress,
        MeasurementMeasurer,
        MeasurementAdminMemo,
        MeasurementTargets,
        Measurements,
    },
    data() {
        return {
            ready: false,
            inquiry: {},
            estimate: undefined,
        };
    },
    created() {
        this.init();
    },
    methods: {
        async init() {
            const { _inquiry: _id } = this.$route.params;
            try {
                const { inquiry } = await api.console.estimate.inquiries.getInquiry({ _id });

                if (inquiry.interiors.length) {
                    inquiry.interiors = inquiry.interiors.map((interior) => {
                        interior.estimates = inquiry.estimates.filter(({ _user }) => _user == interior._id);
                        return interior;
                    });
                }

                if (inquiry.interior !== null) inquiry.interior.estimates = inquiry.estimates.filter(({ _user }) => _user == inquiry.interior._id);

                this.inquiry = inquiry;
                this.ready = true;
            } catch (error) {
                this.handleError(error);
            }
        },
        async save({ message, ...inquiry }) {
            try {
                const { _id } = this.inquiry;
                await api.console.estimate.inquiries.putInquiry({ ...inquiry, _id });

                for (const [key, value] of Object.entries(inquiry)) {
                    if (value?.constructor == Object) {
                        inquiry[key] = { ...this.inquiry[key], ...inquiry[key] };
                    }
                }

                this.inquiry = { ...this.inquiry, ...inquiry };

                alert(message || "저장되었습니다.");
            } catch (error) {
                this.handleError(error);
            }
        },
        async saveInteriors(interior) {
            try {
                var { _id, _interiors } = this.inquiry;
                if (_interiors.includes(interior._id)) throw Error("이미 요청한 업체입니다.");

                var _interiors = [..._interiors, interior._id];
                await api.console.estimate.inquiries.putInquiry({ _id, _interiors });

                this.inquiry._interiors = _interiors;
                this.inquiry.interiors = [...this.inquiry.interiors, interior];
                alert("업체가 추가되었습니다.");
            } catch (error) {
                this.handleError(error);
            }
        },
        async saveInterior(interior) {
            try {
                await api.console.estimate.inquiries.putInquiry({ _id: this.inquiry._id, _interior: interior._id });

                this.inquiry._interior = interior._id;
                this.inquiry.interior = interior._id ? interior : undefined;

                alert(interior._id ? "업체가 선택되었습니다." : "선택이 취소되었습니다.");
            } catch (error) {
                this.handleError(error);
            }
        },
        async saveEstimate(__estimate) {
            try {
                const { file, ...____estimate } = __estimate;

                // create/update estimate doc
                const { estimate } = ____estimate?._id
                    ? await api.console.estimate.putEstimate(____estimate)
                    : await api.console.estimate.postEstimate({ ...____estimate, _inquiry: this.inquiry._id });

                // upload estimate file
                if (file) await api.console.estimate.postFile(estimate._id, file);

                //  update inquiry @BE/DB && @front/data
                if (!____estimate?._id) {
                    const _estimates = [...this.inquiry._estimates, estimate._id];
                    await api.console.estimate.inquiries.putInquiry({ _id: this.inquiry._id, _estimates });
                    this.inquiry._estimates = _estimates;
                    this.inquiry.estimates = [...this.inquiry.estimates, estimate];
                } else {
                    this.inquiry.estimates = this.inquiry.estimates.map((item) => (item._id == ____estimate._id ? estimate : item));
                }

                alert("견적이 저장되었습니다.");
            } catch (error) {
                this.handleError(error);
            }
        },
        async showEstimate(estimate) {
            try {
                this.estimate = { ...estimate };
                if (this.estimate.type == "file") this.estimate.file = await api.getResource(this.estimate.file);
                console.log(this.estimate.file);
                this.$nextTick(() => {
                    switch (estimate.type) {
                        case "data1":
                            this.$refs["popup-estimate1"].open();
                            break;
                        case "data2":
                            this.$refs["popup-estimate2"].open();
                            break;
                        case "file":
                            this.$refs["popup-estimateFile"].open();
                            break;
                    }
                });
            } catch (error) {
                handleError(error);
            }
        },

        async requestEstimate({ _id: _interior }) {
            try {
                const { _id: _inquiry } = this.inquiry;
                await api.console.estimate.inquiries.postRequest({ _inquiry, _interior });
                alert("재견적이 요청되었습니다.");

                const status = "추가견적요청중";
                if (this.inquiry.status !== status) {
                    const { inquiry } = await api.console.estimate.inquiries.putInquiry({ _id: _inquiry, status });
                    this.inquiry.status = inquiry.status;
                }
            } catch (error) {
                this.handleError(error);
            }
        },

        handleError(error) {
            console.error(error);
            alert(error.response ? error.response.data.message : error.message);
        },
    },
    computed: {
        payload() {
            return this.$store.state.payload || {};
        },
        scope() {
            return this.payload.scope || [];
        },
        _user() {
            return this.payload._user;
        },
        isAdmin() {
            return this.scope.includes("console");
        },
        isInterior() {
            return this.scope.includes("interior");
        },
        isMeasurer() {
            return this.scope.includes("measurer");
        },
    },
};
</script>
